import React from "react";
import { STATUS_CONFIG } from "./StatusBadge";

const ALL_STATUSES = Object.keys(STATUS_CONFIG);

const GROUPS = {
  "Buy Signals": ["FRESH_BUY_SIGNAL", "NEAR_BREAKOUT", "PULLBACK_BUY_ZONE", "BUY_CANDIDATE"],
  "Watching":    ["CONSOLIDATION_STAGE", "RE_ENTRY_WATCH", "HOLD"],
  "Caution":     ["WEAKENING_MOMENTUM", "BOOK_PARTIAL_PROFIT", "T2_REACHED"],
  "Exit":        ["SELL_EXIT", "STOP_LOSS_TRIGGERED", "TREND_REVERSAL_WARNING"],
  "No Trade":    ["NO_TRADE_ZONE", "AVOID"],
};

export default function FilterBar({ filters, onChange, totalCount, filteredCount }) {
  const { status, search, minScore, maxScore } = filters;

  function setFilter(key, val) {
    onChange({ ...filters, [key]: val });
  }

  return (
    <div style={{
      background: "white",
      border: "1px solid #e5e7eb",
      borderRadius: 8,
      padding: "12px 16px",
      marginBottom: 16,
      display: "flex",
      flexWrap: "wrap",
      gap: 12,
      alignItems: "center"
    }}>
      {/* Search */}
      <input
        type="text"
        placeholder="Search symbol..."
        value={search}
        onChange={e => setFilter("search", e.target.value.toUpperCase())}
        style={{
          border: "1px solid #d1d5db", borderRadius: 6, padding: "5px 10px",
          fontSize: 13, width: 140, outline: "none", fontFamily: "monospace"
        }}
      />

      {/* Status group filter */}
      <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
        <button
          onClick={() => setFilter("statusGroup", "All")}
          style={{
            border: "1px solid #d1d5db", borderRadius: 5, padding: "4px 10px",
            fontSize: 11, cursor: "pointer", fontWeight: 600,
            background: filters.statusGroup === "All" ? "#1d4ed8" : "white",
            color: filters.statusGroup === "All" ? "white" : "#374151"
          }}
        >All</button>
        {Object.keys(GROUPS).map(g => (
          <button
            key={g}
            onClick={() => setFilter("statusGroup", g)}
            style={{
              border: "1px solid #d1d5db", borderRadius: 5, padding: "4px 10px",
              fontSize: 11, cursor: "pointer", fontWeight: 600,
              background: filters.statusGroup === g ? "#1d4ed8" : "white",
              color: filters.statusGroup === g ? "white" : "#374151"
            }}
          >{g}</button>
        ))}
      </div>

      {/* Score range */}
      <div style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 12, color: "#6b7280" }}>
        <span>Score</span>
        <input
          type="number" min={0} max={100} value={minScore}
          onChange={e => setFilter("minScore", Number(e.target.value))}
          style={{ width: 44, border: "1px solid #d1d5db", borderRadius: 4, padding: "4px 6px", fontSize: 12 }}
        />
        <span>–</span>
        <input
          type="number" min={0} max={100} value={maxScore}
          onChange={e => setFilter("maxScore", Number(e.target.value))}
          style={{ width: 44, border: "1px solid #d1d5db", borderRadius: 4, padding: "4px 6px", fontSize: 12 }}
        />
      </div>

      {/* NR7 / Inside Bar toggles */}
      <label style={{ fontSize: 12, color: "#374151", display: "flex", alignItems: "center", gap: 4, cursor: "pointer" }}>
        <input type="checkbox" checked={filters.nr7Only}
          onChange={e => setFilter("nr7Only", e.target.checked)} />
        NR7 only
      </label>
      <label style={{ fontSize: 12, color: "#374151", display: "flex", alignItems: "center", gap: 4, cursor: "pointer" }}>
        <input type="checkbox" checked={filters.ibOnly}
          onChange={e => setFilter("ibOnly", e.target.checked)} />
        Inside Bar only
      </label>

      {/* Count */}
      <span style={{ marginLeft: "auto", fontSize: 12, color: "#9ca3af" }}>
        {filteredCount} / {totalCount} stocks
      </span>
    </div>
  );
}

export { GROUPS };
